import logo from "@/assets/logotipo.svg";
import MacbookFrame from "./ui/macbookFrame";
import Reveal from "./ui/reveal";

export default function PanelShowcase() {
  return (
    <section id="panel" className="relative">
      {/* Dark stage with the laptop bleeding into the blue band below */}
      <div className="relative bg-nodric-ink pt-20 md:pt-28">
        <Reveal
          direction="none"
          className="flex items-center justify-center gap-6 px-6"
        >
          <img src={logo} alt="Nodric" className="h-7 w-auto md:h-10" />
          <span className="h-8 w-px bg-white/40 md:h-12" />
          <span className="font-display text-2xl tracking-[0.14em] text-white md:text-4xl">
            PANEL
          </span>
        </Reveal>

        <Reveal delay={0.1} className="relative z-20 -mb-[16%] px-6 pt-12">
          <MacbookFrame
            alt="Panel de automatizaciones de Nodric"
            className="mx-auto w-full "
            imageClassName="drop-shadow-[0_40px_80px_rgba(0,0,0,0.5)]"
          />
        </Reveal>
      </div>

      <div className="relative overflow-hidden bg-nodric-blue pt-[20%] pb-20 md:pb-28">
        <div
          aria-hidden
          className="absolute inset-y-0 right-0 hidden w-1/3 opacity-30 lg:block"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)",
            backgroundSize: "64px 64px",
          }}
        />
        <Reveal className="relative z-10 mx-auto max-w-3xl px-6 text-center">
          <h2 className="font-display text-xl leading-relaxed font-medium tracking-[0.06em] text-white md:text-3xl">
            Control visual absoluto.
            <br />
            Tu lógica de negocio, mapeada y ejecutada con precisión
            milimétrica.
          </h2>
        </Reveal>
      </div>
    </section>
  );
}
